import React from 'react'
import PropTypes from 'prop-types'
import { Button, UncontrolledTooltip } from 'reactstrap'
import { FaArrowsV } from 'react-icons/lib/fa'

const showBeforeButton = props =>
  props.canInsertSpaceBefore && props.before

const showAfterButton = props =>
  props.canInsertSpaceAfter && props.after

const InsertEmptySpaceButton = props => {
  const showAfter = showAfterButton(props)
  const showBefore = showBeforeButton(props)

  if (!showBefore && !showAfter) {
    return null
  }

  const target = 'InsertEmptySpaceButton'
  const tooltip = <UncontrolledTooltip target={target}>
    Create space for new content {showAfter ? 'below' : 'above'} this component.
  </UncontrolledTooltip>

  if (showAfter) {
    return <Button id={target} onClick={props.onInsertAfter}><FaArrowsV /> Space below
      {tooltip}
    </Button>
  }

  if (showBefore) {
    return <Button id={target} onClick={props.onInsertBefore}><FaArrowsV /> Space above
      {tooltip}
    </Button>
  }
}

InsertEmptySpaceButton.propTypes = {
  after: PropTypes.bool, // eslint-disable-line
  before: PropTypes.bool, // eslint-disable-line
  canInsertSpaceBefore: PropTypes.bool, // eslint-disable-line
  canInsertSpaceAfter: PropTypes.bool, // eslint-disable-line
  onInsertBefore: PropTypes.func,
  onInsertAfter: PropTypes.func
}

export default InsertEmptySpaceButton



// WEBPACK FOOTER //
// ./src/components/InsertEmptySpaceButton/InsertEmptySpaceButton.js